import React, { useEffect, useState } from "react";
import experienceDetailBG from "../../../assets/images/others/host-side-images/experienceDetailBG.png";
import { ReactComponent as EditBtn } from "../../../assets/images/svgs/edit-btn-svg.svg";
import { ReactComponent as LocationIcon } from "../../../assets/images/svgs/locationDark.svg";
import { ReactComponent as CalandarIcon } from "../../../assets/images/svgs/calendarDark.svg";
import { ReactComponent as ClockIcon } from "../../../assets/images/svgs/clockdark.svg";
import attende1 from "../../../assets/images/others/host-side-images/attende1.png";
import attende2 from "../../../assets/images/others/host-side-images/attende2.png";
import attende3 from "../../../assets/images/others/host-side-images/attende3.png";
import attende4 from "../../../assets/images/others/host-side-images/attende4.png";
import hostImage from "../../../assets/images/others/host-side-images/hostImg.png";
import eventBadge from "../../../assets/images/others/host-side-images/eventBadge.png";
import { useNavigate } from "react-router-dom";
import { siteRoutes } from "../../../utils/helpers/enums/routes";
import { ReactComponent as EditIcon } from "../../../assets/images/svgs/edit.svg";
import { ReactComponent as ScanIcon } from "../../../assets/images/svgs/scan.svg";
import AttendeeBreadcrumb, {
  AttendeBreadcrumbLink,
} from "../../../components/breadcrumbs/AttendeeBreadcrumb";
import RsvpBreadcrumb, {
  RsvpBreadcrumbLink,
} from "components/breadcrumbs/RsvpBreadcrumb";
import useUtils from "hooks/useUtils";
import useAmbassador from "../useHooks";
import WorkshopSessionPopup from "components/popups/workshop-session";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
// import HostProfileDetail from "../host-profile-details";

const AmbassadorExperiencesDetail = () => {
  // const breadcrumbLinks: RsvpBreadcrumbLink[] = [
  //   { title: "Home ", path: siteRoutes.rsvpHome },
  //   { title: "Experiences Detail", path: siteRoutes.rsvpExperiencesDetail },
  // ];
  const [data, setData] = React.useState<any>({})
  const [workshopSessionModal, setWorkshopSessionModal] = useState(false);

  const navigate = useNavigate();
  const { getQueryParams } = useUtils()
  const query = getQueryParams()
  const { getEventDetails,postJoinMeeting } = useAmbassador()

  // hide buuton on the base of startTime
  // const lastSession = data?.event?.workshopSessions[data?.event?.workshopSessions.length - 1];
  // const lastSessionDateTime = new Date(
  //   `${lastSession.startDateWithMonthAndYear} ${lastSession.endTime}`
  // );
  // const hasStarted = new Date() >= lastSessionDateTime;

  const visibleSessions = data?.event?.workshopSessions.slice(0, 3);
  const hasMoreSessions = data?.event?.workshopSessions.length > 3;
  console.log(visibleSessions, hasMoreSessions, "sessions");



  useEffect(() => {
    getEventDetails(query.id, setData)
  }, [query.id]) 

  const handleJoinMeeting = () => {
    postJoinMeeting(query?.id, {})
  }


  return (
    <div>
      <div
        style={{ backgroundImage: `url(${experienceDetailBG})` }}
        className="bg-cover bg-center bg-no-repeat h-full md:h-[500px] w-full"
      >
        <div className="">
          <div className="container">
            <div className="flex flex-wrap justify-between gap-6 items-center">
              {/* <RsvpBreadcrumb links={breadcrumbLinks} /> */}
              {/* <button
                onClick={() => {
                  navigate(siteRoutes.ratings);
                }}
                className="px-5 py-3 flex items-center gap-2 rounded-full text-white bg-primaryBlueBg cursor-pointer"
              >
                <EditIcon />
                Edit Experience
              </button> */}
            </div>
            <div className="flex items-end mt-4 md:mt-14">
              <div className="flex flex-col gap-4">
                <p className="flex items-center text-base text-lightBlackText">
                  <LocationIcon className="mr-1" />   {data?.event?.location}
                </p>
                <h1 className="text-blackie text-2xl md:3xl lg:text-5xl font-medium ">
                  {/* How to improve your <br /> Communication and Social Life */}
                  {data?.event?.title}
                </h1>
                {visibleSessions?.map((session, index) => {
                  const start = new Date(session.startDateTime);
                  const end = new Date(session.endDateTime);

                  const formattedDate = start.toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: 'long',
                    year: 'numeric',
                  });

                  const formattedStartTime = start.toLocaleTimeString('en-US', {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true,
                  });

                  const formattedEndTime = end.toLocaleTimeString('en-US', {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true,
                  });

                  return (
                    <div key={index} className="flex flex-wrap gap-4 text-base text-lightBlackText">
                      <p className="flex items-center gap-1">
                        <CalandarIcon /> {formattedDate}
                      </p>
                      <p className="flex items-center gap-1">
                        <ClockIcon /> {formattedStartTime} to {formattedEndTime}
                      </p>
                    </div>
                  );
                })}

                {hasMoreSessions && (
                  <button
                    onClick={() => setWorkshopSessionModal(true)}
                    className="text-blue-500 underline text-sm w-fit"
                  >
                    See More
                  </button>
                )}

                {/* <div className="flex flex-wrap gap-6 items-center">
                  <div
                    className="flex items-center cursor-pointer" 
                  >
                    {[attende1, attende2, attende3, attende4].map(
                      (attende, index) => (
                        <img
                          key={index}
                          className={`w-[30px] h-[30px] object-cover object-center rounded-full border border-white ${index > 0 ? "ml-[-8px]" : ""
                            }`}
                          src={attende}
                          alt={`Attendee ${index + 1}`}
                        />
                      )
                    )}
                    <span className="text-base text-lightBlackText ml-2">
                      15+ attending
                    </span>
                  </div>
                  <div className="flex flex-wrap gap-5 items-center">
                    <button className="bg-yellowText rounded-md text-white px-4 py-2">
                      Workshop
                    </button>
                    <span className="text-2xl text-blackie font-semibold">
                      $120
                    </span>
                    <span className="text-xl text-lightBlackText">
                      0 Slots Available
                    </span>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container py-6">
        <div className="flex  justify-center mt-4 md:justify-end md:mt-[-120px] lg:mt-[-200px]">
          <div className="flex flex-wrap gap-4 ">
            {data?.event?.badge?.fileDownloadUri &&(
            <div className="flex flex-col items-center justify-center gap-2 rounded-lg bg-white p-4 shadow-md">
              <img
                className="w-[196px] h-[170px]"
                src={concatPathWithBackendUrl(data?.event?.badge?.fileDownloadUri)}
                alt="Event Badge"
                // onClick={() => {
                //   navigate(siteRoutes.rsvpExperiencesDetail);
                // }}
              />
              <span className="text-base font-medium">Event Badge</span>
            </div>
            )}

            {/* <div
              onClick={() => {
                navigate(siteRoutes.rsvpHostProfileDetail);
              }}
              className="cursor-pointer flex flex-col items-center justify-center gap-2 rounded-lg bg-white p-4 shadow-md"
            >
              <img
                className="w-[196px] h-[170px] rounded-full object-contain"
                src={hostImage}
                alt="Host"
              />
              <div className="text-center">
                <p className="font-medium text-lg">Host</p>
                <p className="font-semibold text-base">Steve Johnson</p>
              </div>
            </div> */}
          </div>
        </div>
        <div className="flex flex-wrap sm:flex-nowrap justify-between items-center gap-6 mt-6 sm:mt-16">
          <div className="text-blackie text-3xl">Overview</div>
          <div className="flex gap-3">
            {/* <button
              onClick={() => {
                navigate(siteRoutes.ratings);
              }}
              className="px-5 py-3 flex items-center gap-2 rounded-full text-white bg-rsvpgray cursor-pointer"
            >
              <ScanIcon />
              Scan
            </button> */}

            {/* <button
              onClick={() => {
                navigate(siteRoutes.ratings);
              }}
              className="px-5 py-3 flex items-center justify-center gap-2 rounded-full text-white bg-primaryBlueBg cursor-pointer"
            >
              View Ratings
            </button> */}
            <button 
            onClick={handleJoinMeeting}
              className="px-5 py-3 flex items-center justify-center gap-2 rounded-full text-white bg-primaryBlueBg cursor-pointer"
            >
              Join Event
            </button> 
          </div>
        </div>
        <div className="w-full md:w-[60%] my-5">
          <div>
            <h3 className="text-blackie text-xl font-medium mb-2">
              About Experience
            </h3>
            <p className="text-lightBlackText text-base">
            {data?.event?.description}
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 my-6">
            <div>
              <h3 className="text-blackie text-xl font-medium mb-2">
                Age Group
              </h3>
              <p className="text-lightBlackText text-base">
               {data?.event?.ageGroup.replace(/_/g, " ")}
              </p>
            </div>
            <div>
              <div className="mb-4">
                <h3 className="text-blackie text-xl font-medium mb-2">
                  Language
                </h3>
                <div className="flex gap-2">
                  <span className="px-3 py-1 bg-fade text-blackie rounded-lg text-base">
                   {data?.event?.language}
                  </span>
                </div>
              </div>
            </div>
            <div>
              <h3 className="text-blackie text-xl font-medium mb-2">
                Skill Level
              </h3>
              <p className="text-lightBlackText text-base">
                {data?.event?.skillLevel.replace(/_/g, " ")}
              </p>
            </div>
          </div>
          <div>
            <h2 className="text-2xl font-medium text-blackie mb-2">Details</h2>

            <div>
              <h3 className="text-blackie text-xl font-medium mb-2">
                Learning Activity
              </h3>
              <p className="text-lightBlackText text-base">
                {data?.event?.description}
              </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 my-6">
              <div>
                <h3 className="text-blackie text-xl font-medium mb-2">
                  Core Concepts
                </h3>
                {data?.event?.coreConcept.map((item:any, index)=>(
                <p className="text-lightBlackText text-base">
                 {item.replace(/_/g," ")}
                </p>
                ))}
              </div>
              <div>
                <h3 className="text-blackie text-xl font-medium mb-2">
                  Parent Supervision
                </h3>
                <p className="text-lightBlackText text-base">
                  Guardian Presence Required
                </p>
              </div>
              {/* <div>
                <h3 className="text-blackie text-xl font-medium mb-2">
                  Special Instructions
                </h3>
                <p className="text-lightBlackText text-base">
                  Parking, Checking in
                </p>
              </div>
              <div>
                <h3 className="text-blackie text-xl font-medium mb-2">
                  Physical Consideration
                </h3>
                <ul className="text-lightBlackText text-base list-disc list-inside">
                  <li>Requires lots of walking or standing</li>
                  <li>Not handicap accessible</li>
                </ul>
              </div> */}
            </div>
          </div>
          <div>
            <h2 className="text-2xl font-semibold text-blackie mb-6">
              Mission
            </h2>
            <div>
              <h3 className="text-blackie text-xl font-medium mb-2">Mission</h3>
              <p className="text-lightBlackText text-base">
               {data?.host?.mission}
              </p>
            </div>
            <div>
              <h3 className="text-blackie text-xl font-medium mb-2 mt-3">
                About{" "}
              </h3>
              <p className="text-lightBlackText text-base">
               {data?.host?.about}
              </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 my-6">
              <div className="">
                <p className="text-blackie  font-medium text-xl">
                  Business Name
                </p>
                <p className="text-lightBlackText text-base">
                 { data?.host?.businessName}
                </p>
              </div>
              {/* <div className="">
                <p className="text-blackie text-xl font-medium ">
                  Business Website
                </p>
                <a
                  href="https://www.alphaenterprises.pk"
                  className="text-blue-600 text-base"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.alphaenterprises.pk
                </a>
              </div> */}
            </div>
          </div>
          {/* <div>
            <p>
              Note: integration k wqt set krna he yahn 2 btn ane hn conditon
              base
            </p>
            <div className="mt-6">
              <button
                onClick={() => {
                  navigate(siteRoutes.minorTicket);
                }}
                className="px-5 py-2 flex gap-2 rounded-full text-white bg-primaryBlueBg cursor-pointer"
              >
                View Pass
              </button>
            </div>
          </div> */}
        </div>
      </div>

      {workshopSessionModal && (
        <WorkshopSessionPopup
          isOpen={workshopSessionModal}
          onClose={() => setWorkshopSessionModal(false)}
          sessions={data.event.workshopSessions}
        />
      )}
    </div>
  );
};

export default AmbassadorExperiencesDetail;
